import "../css/payment.css";
import CuDropdown from "../../common_component/component/CuDropdown";
import CuInput from "../../all-patient/components/CuInput";
import { LuPlus } from "react-icons/lu";
import { useItemsFilter } from "../../_helper/actions/app/items";
import { useAtom } from "jotai";
import { clinicAtom } from "../../_helper/constant/constant-atom";
import { ApiEndPoint } from "../../_helper/constant/api-types";
import { useEffect, useMemo, useState } from "react";
import moment from "moment";
import { toast } from "react-toastify";
import { IoClose } from "react-icons/io5";

// const statusOptions = [
//   { key: 1, value: "partial", text: "Partial" },
//   { key: 2, value: "paid", text: "Paid" },
// ];

const Payment = ({
  payments,
  setPayments,
  invoicePayload,
  fullPaymentForm,
  setFullPaymentForm,
  isFull,
  setIsFull,
}) => {
  const [clinic] = useAtom(clinicAtom);
  const [paymentOptions, setPaymentOptions] = useState([]);
  // const [isFull, setIsFull] = useState(true);

  const receivedAmt = useMemo(() => {
    const receivingAmt = payments?.reduce(
      (acc, payment) => acc + Number(payment?.received_payment),
      0
    );
    return Number(invoicePayload?.invoice_total) - Number(receivingAmt);
  }, [invoicePayload?.invoice_total]);

  // const [fullPaymentForm, setFullPaymentForm] = useState({
  //   status: "paid",
  //   transaction_date: moment().format("YYYY-MM-DD"),
  //   payment_mode: 1,
  //   transaction_details: "",
  //   received_payment: 0,
  // });

  const handleAddPayment = () => {
    if (Number(receivedAmt) > 0) {
      const blankPayment = {
        status: "paid",
        transaction_date: moment().format("YYYY-MM-DD"),
        payment_mode: 1,
        transaction_details: "",
        received_payment: 0,
        // received_payment:
        //   Number(invoicePayload?.invoice_total) - Number(receivedAmt),
      };
      setPayments((prev) => [...prev, blankPayment]);
    } else {
      toast.error("Cannot pay more than the invoice");
    }
  };

  const handleRemovePayment = (idx) => {
    if (payments?.length > 1) {
      setPayments((prev) => {
        const temp = [...prev];
        temp?.splice(idx, 1);
        return temp;
      });
    }
  };

  const handleChange = (value, label, idx) => {
    // if (label === "status" && value === "paid") {
    //   setPayments((prev) => {
    //     const temp = [...prev];
    //     temp[idx][label] = value;
    //     temp[idx].received_payment = invoicePayload?.invoice_total;
    //     return temp;
    //   });
    // } else {
    //   setPayments((prev) => {
    //     const temp = [...prev];
    //     temp[idx][label] = value;
    //     return temp;
    //   });
    // }
    setPayments((prev) => {
      const temp = [...prev];
      temp[idx][label] = value;
      return temp;
    });
  };

  const handleFullPChange = (value, label) => {
    setFullPaymentForm((prev) => ({
      ...prev,
      [label]: value,
    }));
  };

  const queryForPaymentOptions = `?action=getPaymentOptions&frontend=True&clinic_id=${clinic?.id}`;
  const { data } = useItemsFilter(
    ApiEndPoint.PAYMENT_OPTIONS,
    queryForPaymentOptions,
    clinic?.id ? true : false
  );

  const paymentOption = useMemo(() => {
    const paymentOptionObj = {};
    data?.forEach((ele) => {
      if (ele?.id && ele?.type) {
        paymentOptionObj[ele?.id] = ele?.type;
      }
    });
    return paymentOptionObj;
  }, [data]);

  useEffect(() => {
    if (data) {
      const modifiedOptions = data?.map((ele) => {
        return { key: ele?.id, value: ele?.id, text: ele?.type };
      });

      setPaymentOptions(modifiedOptions);
    }
  }, [data]);

  useEffect(() => {
    if (receivedAmt) {
      setFullPaymentForm((prev) => ({
        ...prev,
        received_payment: receivedAmt,
      }));
    }
  }, [receivedAmt]);

  // const getAmtDisable = (idx, payment) => {
  //   if (payments?.length - 1 === idx && payment?.status === "partial") {
  //     return false;
  //   }
  //   return true;
  // };

  return (
    <div className="w-full">
      <div className="flex items-center gap-6 py-3">
        <div className="flex items-center gap-2">
          <label>Full Payment</label>
          <input
            type="radio"
            className="cursor-pointer"
            checked={isFull}
            onChange={(e) => setIsFull(true)}
          />
        </div>
        <div className="flex items-center gap-2">
          <label>Other</label>
          <input
            type="radio"
            className="cursor-pointer"
            checked={!isFull}
            onChange={(e) => setIsFull(false)}
          />
        </div>
      </div>
      {!isFull &&
        payments?.map((payment, idx) => {
          return (
            <div className="flex flex-col gap-5 text-sm" key={idx}>
              <div>
                {payments?.length > 1 && (
                  <div
                    className={`flex items-center justify-between ${idx + 1 > 1 ? "pt-4" : ""}`}
                  >
                    <div className="text-[#000000] text-[16px] leading-[18.4px] font-bold">{`Part ${
                      idx + 1
                    }`}</div>
                    <IoClose
                      color="red"
                      size={19}
                      className="cursor-pointer"
                      onClick={() => handleRemovePayment(idx)}
                    />
                  </div>
                )}
                {/* <label>Status</label>
              <CuDropdown
                options={statusOptions}
                value={payment?.status}
                onChange={(val) => handleChange(val, "status", idx)}
              /> */}
              </div>
              <div>
                <CuInput
                  label="Date"
                  type="date"
                  value={payment?.transaction_date}
                  onChange={(e) =>
                    handleChange(e.target.value, "transaction_date", idx)
                  }
                />
              </div>
              <div>
                <label>Type</label>
                <CuDropdown
                  options={paymentOptions}
                  value={payment?.payment_mode}
                  onChange={(val) =>
                    handleChange(Number(val), "payment_mode", idx)
                  }
                />
              </div>
              <div>
                <CuInput
                  label="Description"
                  type="text"
                  value={payment?.transaction_details}
                  onChange={(e) =>
                    handleChange(e.target.value, "transaction_details", idx)
                  }
                />
              </div>
              <div>
                <CuInput
                  label="Amount"
                  type="number"
                  value={payment?.received_payment}
                  onChange={(e) =>
                    handleChange(e.target.value, "received_payment", idx)
                  }
                  // disabled={getAmtDisable(idx, payment)}
                  disabled={isFull}
                />
              </div>
              {/* {payment?.status === "partial" &&
                idx === payments?.length - 1 && (
                  <div>
                    <CuInput
                      label="Remaining Amount"
                      disabled={true}
                      value={
                        Number(invoicePayload?.invoice_total) -
                          Number(receivedAmt) || ""
                      }
                    />
                  </div>
                )} */}
            </div>
          );
        })}
      {isFull && (
        <>
          <div className="pb-3">
            <span>Last Transactions</span>
            {payments?.map((prevTran) => {
              if (prevTran?.id) {
                return (
                  <div
                    className="flex items-center justify-between gap-4 text-[#000000] text-[14px] rounded-lg border px-3 h-[42px]"
                    key={prevTran?.id}
                  >
                    <span>{prevTran?.transaction_date}</span>
                    <span>{paymentOption[prevTran?.payment_mode]}</span>
                    <span>₹ {prevTran?.received_payment}</span>
                  </div>
                );
              }
            })}
          </div>
          <div className="flex flex-col gap-5 text-sm">
            <div>
              <CuInput
                label="Date"
                type="date"
                value={fullPaymentForm?.transaction_date}
                onChange={(e) =>
                  handleFullPChange(e.target.value, "transaction_date")
                }
              />
            </div>
            <div>
              <label>Type</label>
              <CuDropdown
                options={paymentOptions}
                value={fullPaymentForm?.payment_mode}
                onChange={(val) =>
                  handleFullPChange(Number(val), "payment_mode")
                }
              />
            </div>
            <div>
              <CuInput
                label="Description"
                type="text"
                value={fullPaymentForm?.transaction_details}
                onChange={(e) =>
                  handleFullPChange(e.target.value, "transaction_details")
                }
              />
            </div>
            <div>
              <CuInput
                label="Amount"
                type="number"
                value={fullPaymentForm?.received_payment}
                onChange={(e) =>
                  handleFullPChange(e.target.value, "received_payment")
                }
                // disabled={getAmtDisable(idx, payment)}
                disabled={isFull}
              />
            </div>
          </div>
        </>
      )}
      {!isFull && (
        <div
          className="flex items-center justify-center gap-2 mt-5 cursor-pointer"
          onClick={handleAddPayment}
        >
          <span className="text-lg">Add Payment</span>
          <LuPlus size={20} color="gray" />
        </div>
      )}
    </div>
  );
};

export default Payment;
